/**
 * seasons constants
 */
export const SEASONS_SET = 'SEASONS_SET';
export const SEASONS_MERGE = 'SEASONS_MERGE';
export const SEASON_SET = 'SEASON_SET';
